module.exports = __webpack_public_path__ + "assets/totallyConfident.175e572a.svg";